import { Navigate } from 'react-router';
import { usePermissions } from '@/hooks/usePermissions';
import { useAuthStore } from '@/stores/auth-store';
import { ROLE_TYPES } from '@scio3/shared-types';

/**
 * Route guard that redirects restricted roles (READ_ONLY, CONTENT_PROPOSAL, CONTENT_APPROVAL)
 * to the Screens page. Wraps individual route elements — NOT an Outlet layout route.
 */
export function RestrictedRoute({ children }: { children: React.ReactNode }) {
  const me = useAuthStore((s) => s.me);
  const { teamRole } = usePermissions();

  // While user data is loading, don't flash redirect — show nothing (ProtectedRoute handles auth loading)
  if (!me) return null;

  const isRestricted =
    teamRole === ROLE_TYPES.READ_ONLY ||
    teamRole === ROLE_TYPES.CONTENT_PROPOSAL ||
    teamRole === ROLE_TYPES.CONTENT_APPROVAL;

  if (isRestricted) {
    return <Navigate to="/app/screenManagement" replace />;
  }

  return <>{children}</>;
}
